import { createFileRoute } from '@tanstack/react-router';

import { Error401 } from '@@containers/App/Error401';

export const Route = createFileRoute('/401')({
    component: Error401,
});
